import * as _ from "lodash";
import "select2";
import { TimezoneCollection } from "../../../../collections/Timezones";
import { DashboardChannel } from "../../../../models/DashboardChannel";
import {
    BaseDashboardWidgetView,
    BaseDashboardWidgetViewOptions,
} from "../../../dashboard/widgets/_BaseWidgetView";
import {
    CHART_DATA_RANGE,
    CHART_SIZE
} from "../../../dashboard/widgets/chart/ChartHelper";
import { getAggPeriodName, getDataRangeName } from "../../ReportUtils";

declare const App: any;

export class CSVDataWidgetView extends BaseDashboardWidgetView {
    protected template = _.template(
        require("templates/reports/widgets/csvdatawidget/summary.html")
    );


    constructor(options: BaseDashboardWidgetViewOptions) {
        super(
            <any>_.extend(
                {
                    tagName: "div",
                    className: "widget",
                    events: {
                        // Widget related buttons
                        "click .w-settings .remove": "handleRemoveWidgetClick",
                        "click .w-delete-widget .w-cancel":
                            "handleRemoveWidgetCancelClick",
                        "click .w-delete-widget .w-confirm":
                            "handleRemoveWidgetConfirmClick",
                        "click .w-settings .gear": "handleEditWidgetClick",
                        "click .w-settings .clone": "handleCloneWidget",
                    },
                },
                options
            )
        );
    }

    render() {
        // Get channels for this table
        const widgetId = this.options.widget.get("id");
        const dashboardChannels = <DashboardChannel[]>(
            this.options.dashboardChannelCollection.where({
                dashboard_widget_id: widgetId,
            })
        );

        // Get install names
        const installIDs: number[] = [];
        const installNames: string[] = [];
        for (const dchannel of dashboardChannels) {
            const installID = dchannel.get("install_id");
            if(installIDs.includes(installID)) continue;
            installIDs.push(installID);

            // Get install name from ID
            const install = this.options.manager.options.installCollection.findWhere({
                id: installID,
            });
            installNames.push(install.getDisplayName());
        }

        const dataRangeValue = this.options.widget.getParamValue("CHART_DATA_RANGE", CHART_DATA_RANGE.DEFAULT);
        let rangeLabel: string;
        if (dataRangeValue === CHART_DATA_RANGE.CUSTOM) {
            const dataRangeFrom = this.options.widget.getParamValue("CHART_DATA_RANGE_FROM", CHART_DATA_RANGE.DEFAULT);
            const dataRangeTo = this.options.widget.getParamValue("CHART_DATA_RANGE_TO", CHART_DATA_RANGE.DEFAULT);
            rangeLabel = getDataRangeName(dataRangeValue, dataRangeFrom, dataRangeTo);
        } else if (dataRangeValue === CHART_DATA_RANGE.CUSTOM_DAILY) {
            const dataRangeDailyFrom = this.options.widget.getParamValue("DAILY_TIME_TO", CHART_DATA_RANGE.DEFAULT);
            const dataRangeDailyTo = this.options.widget.getParamValue("DAILY_TIME_FROM", CHART_DATA_RANGE.DEFAULT);
            rangeLabel = getDataRangeName(dataRangeValue, dataRangeDailyFrom, dataRangeDailyTo);
        } else {
            rangeLabel = getDataRangeName(dataRangeValue);
        }
        
        // Get timezone display name
        const timezones = new TimezoneCollection();
        const timezone = this.options.widget.getParamValue('CHART_TIMEZONE', this.options.currentUser.get('timezone'));
        const timezoneLabel = timezones.findWhere({ momentjs: timezone }).getDisplayTimezone();

        const title = this.options.widget.getParamValue('CHART_TITLE', 'CSV File');
        const aggPeriod = getAggPeriodName(this.options.widget.getParamValue('CHART_AGGREGATION_PERIOD', '0'));

        this.$el.html(
            this.template({
                aggPeriod: aggPeriod,
                cloneable: this.options.cloneable,
                deletable: this.options.deletable,
                editable: this.options.editable,
                installNames: installNames,
                movable: this.options.movable,
                permissionCollection: this.options.permissionCollection,
                rangeLabel: rangeLabel,
                reportId: this.options.report?.get("id"),
                timezoneLabel: timezoneLabel,
                title: title,
                widget: this.options.widget,
            })
        );

        this.$el.addClass(
            "widget-w-" +
                this.options.widget.getParamValue(
                    "CHART_SIZE",
                    CHART_SIZE.SIZE_6
                ) + " csv-data-widget"
        );
        this.$el.attr("data-widget-id", this.options.widget.get("id"));
               
        // Tell Packery to do its magic again after the template is loaded, so that our widgets are re-organized
        App.Bus.trigger(
            "dashboard:category:" + this.options.categoryId + ":layout"
        );

        this.setLoading(false);
        this.delegateEvents();
        return this;
    }

    private setLoading(loading: boolean) {
        this.$(".w-table .modal-form-spinner").toggleClass("hidden", !loading);
        this.$(".w-table .summary").toggleClass("hidden", loading);
    }


    remove() {
        // Terminate web workers and unload everything
        return super.remove();
    }

}



// WEBPACK FOOTER //
// ./srv/public/js/views/reports/widgets/csvdatawidget/CSVDataWidgetView.ts